import { Link } from 'react-router-dom'

import { MarketPageHeader } from '../components/MarketPageHeader'

/**
 * Стартовый экран остаётся доступен без включённой интеграции: закупщик видит,
 * зачем нужен раздел, и сразу попадает в место, где появится настройка.
 * Запросов к выключенному API здесь намеренно нет.
 */
export const InventoryIntegrationIntroScreen = () => (
  <section className="market-page">
    <MarketPageHeader
      title="Заказ по остаткам"
      description="Планируйте закупки по фактическим остаткам, расходу и сроку поставки."
    />

    <div className="market-empty-state">
      <h2>Подключите ERP-систему</h2>
      <p className="market-muted">
        После подключения мы возьмём остатки со складов, посчитаем расход и подскажем, что заказать у ваших
        поставщиков.
      </p>
      <p className="market-muted">
        Сейчас доступна интеграция с <strong>iiko Server</strong>. Поддержку других ERP-систем добавим позже.
      </p>
      <Link className="echat-btn echat-btn--primary" to="/settings/integrations">
        Подключить iiko
      </Link>
    </div>
  </section>
)
